import React from "react";

import { PatientAgentLogo } from "~/assets";

export const Support = () => {
  return (
    <main className="flex flex-col items-center justify-center p-10">
      <div className="mb-12 w-full max-w-64">
        <img src={PatientAgentLogo} alt="logo" className="w-full" />
      </div>

      <div>
        <h1 className="mb-1 text-left text-2xl font-bold text-[#111827]">
          Support
        </h1>

        <h2 className="mb-6 text-xl font-semibold text-[#111827]">
          Permanently delete my account
        </h2>

        <div className="flex flex-col gap-y-8 text-[#4B5563]">
          <p>
            If you wish to permanently delete your account and all associated
            data from this app, you can submit a request to the Patient Agent
            support team.{" "}
          </p>

          <p>
            Please send an email to{" "}
            <a className="font-semibold" href="mailto:support@patientagent.com">
              support@patientagent.com
            </a>{" "}
            with your request.
          </p>
        </div>
      </div>
    </main>
  );
};
